import { Component, OnInit } from '@angular/core';
import { EnvService } from '@hrra/core';
import { select, Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LocaleService } from 'src/app/core/locale.service';
import { selectCurrentLanguage, selectIsSignedIn, selectLanguages, selectUser } from 'src/app/root-store/selectors';
import { AppState, CurrentInfoState } from 'src/app/root-store/state';
import { UserTypeEnum } from 'src/app/user/shared/models/enums/user-type-enum';
import { User } from 'src/app/user/shared/models/user-model';
import { getFavoritesIcon, hasAppsLauncher } from '../header-branding';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit {

  isSignedIn$: Observable<boolean>;
  user$: Observable<User>;
  currentLanguage$: Observable<string>;
  languages$: Observable<string[]>;
  providerWebsiteId: number = this.envService.tenantId;
  showAppsLauncher = hasAppsLauncher(this.envService.theme);
  favoritesIcon = getFavoritesIcon(this.envService.theme);

  userType: any;
  
  constructor(
    private translate: TranslateService, 
    private store: Store<AppState>,
    private envService: EnvService,
    private localeService: LocaleService
  )
  { 
    this.userType = UserTypeEnum
  }

  ngOnInit(): void {
    this.isSignedIn$ = this.store.pipe(select(selectIsSignedIn));
    this.user$ = this.store.pipe(select(selectUser));
    this.currentLanguage$ = this.store.pipe(select(selectCurrentLanguage));
    // only offer languages the locale url prefixes can serve, switching to any
    // other one would fail when building the target url
    const supportedLocales = this.localeService.getSupportedLocales();
    this.languages$ = this.store.pipe(
      select(selectLanguages),
      map(languages => languages.filter(language => supportedLocales.includes(language)))
    );
  }
}